<app-breadcrumb></app-breadcrumb>
<div class="md:w-2/3">
  <mat-card class="bg-paper import-accounts">
    <div class="px-6 pb-4">
      <app-import-accounts-form [formGroup]="keystoresFormGroup" #importAccounts></app-import-accounts-form>
      <app-import-protection #slashingProtection></app-import-protection>
      <div class="my-4"></div>
      <div class="flex">
        <a routerLink="/dashboard/wallet/accounts"><button mat-raised-button color="accent">Back to Accounts</button></a>
        <div class="mx-3"></div>
        <div class="flex">
          <div class="btn-container">
            <button
              mat-raised-button
              color="primary"
              (click)="submit()"
              [disabled]="loading || keystoresFormGroup.invalid || slashingProtection.invalid">
              Submit Keystores
            </button>
            <div class="btn-progress" *ngIf="loading">
              <mat-spinner color="primary" [diameter]="25"></mat-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
</div>
